import React from 'react';

var Search = (function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#7A34FF' : _ref$color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '24' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
    fill: color,
    fillRule: "evenodd"
  }));
});

export { Search as default };
//# sourceMappingURL=search.js.map
